import url_acc from '@/urls/accounts'
import { sendDeleteRequest, sendPostRequest, sendPutRequest } from '@/helper/requests'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  createUserMail: ({ commit }, {
    data, finalizer = () => {
    }, catcher = () => {
    }
  }) => {
    /**
     * Создает новую почту пользователя
     * @param {Object} commit - контекст Vuex
     * @param {Object} data - данные почты для создания
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = url_acc.PROFILE.MAIL.CREATE()
    sendPostRequest(
      url, data, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
  deleteUserMail: ({ commit }, { id, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Удаляет почту пользователя
     * @param {Object} commit - контекст Vuex
     * @param {string|number} id - идентификатор почты
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = url_acc.PROFILE.MAIL.DELETE(id)
    sendDeleteRequest(
      url, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
  updateUserMail: ({ commit }, {
    data, id, finalizer = () => {
    }, catcher = () => {
    }
  }) => {
    /**
     * Обновляет почту пользователя
     * @param {Object} commit - контекст Vuex
     * @param {Object} data - обновленные данные почты
     * @param {string|number} id - идентификатор почты
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = url_acc.PROFILE.MAIL.UPDATE(id)
    sendPutRequest(
      url, data, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
}
export default {
  state,
  mutations,
  getters,
  actions
}
